import { Spin } from "antd";
import React from "react";

function PageLoader() {
  return (
    <div className="flex justify-center items-center w-full h-full">
      <Spin />
    </div>
  );
}

export default PageLoader;
